<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="医院" prop="hospitalId" >
        <a-input-search
          v-model="hospitalName"
          placeholder="请选择医院"
          enter-button="选择"
          @search="handleSelectHospital"
          :readonly="true"
        />
        <!-- 医院选择弹窗 -->
        <table-select-modal
          :visible.sync="hospitalSelectVisible"
          title="选择医院"
          :api-method="pageHospital"
          :columns="hospitalColumns"
          search-label="医院名称"
          search-key="hospitalName"
          search-placeholder="请输入医院名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          @ok="handleHospitalSelected"
          @cancel="handleHospitalCancel"
        >
        </table-select-modal>
      </a-form-model-item>
      <a-form-model-item label="科室名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入内容"  allow-clear />
      </a-form-model-item>
      <a-form-model-item label="科室形象照片" prop="logo" >
        <file-upload type="image" :defaultList="form.logoArr" :count="6"
                     @input="getImg($event, 'logo')"/>
      </a-form-model-item>
      <a-form-model-item label="科室简介" prop="content" >
        <editor ref="contentEditor" v-model="form.content" :min-height="192" editor-id="depart-content-editor"/>
      </a-form-model-item>
      <a-form-model-item label="固定荣誉" prop="fixedHonors">
        <a-checkbox :checked="form.isTop100 === 1" @change="handleFixedHonorChange('top100')">
          全国百强科室
        </a-checkbox>
      </a-form-model-item>
      <a-form-model-item label="自定义荣誉" prop="customHonors">
        <div v-for="(honor, index) in form.customHonors" :key="index" style="margin-bottom: 8px;">
          <a-input
            v-model="form.customHonors[index]"
            placeholder="请输入自定义荣誉名称"
            style="width: calc(100% - 80px); margin-right: 8px;"
          />
          <a-button type="danger" size="small" @click="removeCustomHonor(index)" v-if="form.customHonors.length > 1">
            删除
          </a-button>
        </div>
        <a-button type="dashed" size="small" @click="addCustomHonor" style="width: 100%;">
          <a-icon type="plus" /> 添加自定义荣誉
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="荣誉凭证" prop="certificateArr">
        <file-upload
          type="image"
          :defaultList="form.certificateArr"
          :count="9"
          @input="getImg($event, 'certificate')"/>
      </a-form-model-item>

      <a-form-model-item label="所属科室" prop="departId" >
        <a-input-search
          v-model="departName"
          placeholder="请选择所属科室"
          enter-button="选择"
          @search="handleSelectDepart"
          :readonly="true"
        />
        <!-- 所属科室选择弹窗 -->
        <table-select-modal
          :visible.sync="departSelectVisible"
          title="选择所属科室"
          :api-method="pagePlatformDepart"
          :columns="departColumns"
          search-label="科室名称"
          search-key="name"
          search-placeholder="请输入科室名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          @ok="handleDepartSelected"
          @cancel="handleDepartCancel"
        >
        </table-select-modal>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHospitalDepart, addDepart, updateDepart,listDepart,pageDepart } from '@/api/hospital/depart'
import {guid} from "@/utils/ruoyi";
import {getDicts} from "@/api/system/dict/data";
import {listHospital, getHospital, pageHospital} from "@/api/hospital/hospital";
import {getDepart, treeDepart,listPlatformDepart,pageDepart as pagePlatformDepart} from "@/api/depart/depart";
import TableSelectModal from '@/components/TableSelectModal'
import Editor from '@/components/Editor'
import FileUpload from '@/components/FileUpload'
import { processImageUrl } from '@/utils/util'


export default {
  name: 'CreateForm',
  dicts: ['hospital_level', 'hospital_nature', 'hospital_type'],
  props: {
  },
  components: {
    TableSelectModal,
    Editor,
    FileUpload
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      hospitalList:[],
      hospitalSelectVisible: false,
      hospitalName: '',
      parentDepartSelectVisible: false,
      parentDepartName: '',
      departList:[],
      departSelect:null,
      departSelectVisible: false,
      departName: '',
      platformDepartList:[],
      // 表单参数
      form: {
        id: null,
        departId:null,
        logo: null,
        logoArr: [],
        logoCount: 6,
        content: null,
        honor: null,
        customHonors: [''],
        isTop100: 0,
        top100Rank: null,
        hospitalId: null,
        certificate: null,
        certificateArr: [],
        certificateCount: 9,
        name: null,
        level: null,
        pid: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        hospitalId: [
          { required: true, message: '医院不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '科室名称不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    // 动态生成医院表格列
    hospitalColumns() {
      return [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          width: 200
        },
        {
          title: '地区',
          dataIndex: 'areaName',
          width: 150
        },
        {
          title: '医院等级',
          dataIndex: 'level',
          width: 100
        },
        {
          title: '医院性质',
          dataIndex: 'nature',
          width: 100
        },
        {
          title: '医院类型',
          dataIndex: 'type',
          width: 100
        }
      ]
    },
    // 动态生成科室表格列
    departColumns() {
      return [
        {
          title: '科室名称',
          dataIndex: 'name',
          ellipsis: true,
          width: 200
        }
        // ,
        // {
        //   title: '科室简介',
        //   dataIndex: 'content',
        //   ellipsis: true,
        //   width: 300
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.initData()
  },
  activated() {
    this.initData()
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    pageHospital,
    pageDepart,
    pagePlatformDepart,

    handleDepartChange(val,selectedOptions){
      console.log(val,selectedOptions)
      this.form.departId = val[val.length-1]
    },

    initData(){
      listDepart({pid:0}).then(res=>{
        this.departList = res.data
      })
      listPlatformDepart().then(res=>{
        this.platformDepartList = res.data
      })
    },

    // 打开医院选择弹窗
    handleSelectHospital () {
      this.hospitalSelectVisible = true
    },

    // 医院选择确定
    handleHospitalSelected (hospital) {
      this.form.hospitalId = hospital.id
      this.hospitalName = hospital.hospitalName
      this.hospitalSelectVisible = false
    },

    // 医院选择取消
    handleHospitalCancel () {
      this.hospitalSelectVisible = false
    },

    // 打开所属科室选择弹窗
    handleSelectDepart () {
      this.departSelectVisible = true
    },

    // 所属科室选择确定
    handleDepartSelected (depart) {
      this.form.departId = depart.id
      this.departName = depart.name
      this.departSelectVisible = false
    },

    // 所属科室选择取消
    handleDepartCancel () {
      this.departSelectVisible = false
    },

    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false

    },
    // 表单重置
    reset () {
      this.formType = 1
      this.departSelect = null,
      this.hospitalName = '',
      this.parentDepartName = '',
      this.departName = '',
      this.form = {
        id: null,
        departId: null,
        logo: null,
        logoArr: [],
        logoCount: 6,
        content: null,
        honor: null,
        customHonors: [''],
        isTop100: 0,
        top100Rank: null,
        hospitalId: null,
        certificate: null,
        certificateArr: [],
        certificateCount: 9,
        name: null,
        level: null,
        pid: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHospitalDepart({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        this.departSelect = [this.form.departId]
        let that = this
        this.form.logoArr = []
        if(this.form.logo){
          this.form.logo.split(',').forEach(item =>{
            that.form.logoArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }
        // 处理荣誉回显
        this.$set(this.form, 'isTop100', this.form.isTop100 || 0)
        this.$set(this.form, 'top100Rank', this.form.top100Rank || null)

        // 解析荣誉：从逗号分隔的字符串中解析
        this.$set(this.form, 'customHonors', [])
        if (this.form.honor) {
          const honorList = this.form.honor.split(',').map(item => item.trim())
          // 过滤掉"全国百强科室"，获取自定义荣誉
          const customHonorList = honorList.filter(item => item && item !== '全国百强科室')
          this.$set(this.form, 'customHonors', customHonorList.length > 0 ? customHonorList : [''])
        } else {
          this.$set(this.form, 'customHonors', [''])
        }
        // 处理荣誉凭证回显
        this.form.certificateArr = []
        if (this.form.certificate) {
          const that = this
          this.form.certificate.split(',').forEach(item => {
            that.form.certificateArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }
        // 回显医院名称
        if (this.form.hospitalId) {
          this.loadHospitalName(this.form.hospitalId)
        }
        // 回显所属科室名称
        if (this.form.departId) {
          this.loadDepartName(this.form.departId)
        }
      })
    },

    // 加载医院名称用于回显
    loadHospitalName(hospitalId) {
      getHospital({ id: hospitalId }).then(res => {
        if (res.data) {
          this.hospitalName = res.data.hospitalName
        }
      })
    },

    // 加载所属科室名称用于回显
    loadDepartName(departId) {
      if (!departId || departId <= 0) {
        return
      }
      getDepart({ id: departId }).then(res => {
        if (res.data) {
          this.departName = res.data.name
        }
      })
    },

    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].halfUrl
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.halfUrl }).join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // 处理荣誉数据：使用逗号分隔的字符串格式
          const honorList = []

          // 固定荣誉放在最前面
          if (this.form.isTop100 === 1) {
            honorList.push('全国百强科室')
          }

          // 自定义荣誉（过滤空值）
          if (this.form.customHonors && this.form.customHonors.length > 0) {
            const customHonors = this.form.customHonors.filter(h => h && h.trim() !== '')
            honorList.push(...customHonors)
          }

          // 转为逗号分隔的字符串
          this.form.honor = honorList.length > 0 ? honorList.join(',') : null
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDepart(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDepart(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 添加自定义荣誉
    addCustomHonor () {
      this.form.customHonors.push('')
    },
    // 删除自定义荣誉
    removeCustomHonor (index) {
      this.form.customHonors.splice(index, 1)
      // 如果删除了最后一个，添加一个空项
      if (this.form.customHonors.length === 0) {
        this.form.customHonors.push('')
      }
    },
    // 处理固定荣誉变化
    handleFixedHonorChange (type) {
      if (type === 'top100') {
        this.form.isTop100 = this.form.isTop100 === 1 ? 0 : 1
        // 如果设置为全国百强科室，但没有设置排名，可以提示（可选）
        if (this.form.isTop100 === 1 && !this.form.top100Rank) {
          this.$message.info('已设置为全国百强科室，建议设置百强名次')
        }
      }
    }
  }
}
</script>
